import { Typography } from '@vivaahealth/design-system';

import styles from '../index.module.css';
import React, { useEffect, useRef } from 'react';
import { SearchItem } from '../data';

interface ReasonForVisitSuggestionProps {
  data: SearchItem;
  input: string;
  onClicked: () => void;
  isSelected: boolean;
}

const ReasonForVisitSuggestion: React.FC<ReasonForVisitSuggestionProps> = (
  props,
) => {
  const onClickHandler = (event: React.MouseEvent<HTMLInputElement>) => {
    props.onClicked();
  };
  const { input, data, isSelected } = props;

  const scrollRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (isSelected && scrollRef && scrollRef.current) {
      scrollRef.current.scrollIntoView({
        block: 'end',
        inline: 'nearest',
      });
    }
  });

  const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (
      document.activeElement === scrollRef.current &&
      e.key.toLowerCase() === 'enter'
    ) {
      props.onClicked();
    }
  };

  const capitalizedName =
    data.name.length > 1
      ? data.name.charAt(0).toUpperCase() + data.name.slice(1)
      : data.name.toUpperCase();
  let startIndex = capitalizedName.toLowerCase().indexOf(input.toLowerCase());
  let endIndex = startIndex + input.length;

  return (
    <div
      className={styles.BasicOption}
      key={capitalizedName}
      onClick={onClickHandler}
      onKeyDown={handleKeyPress}
      ref={scrollRef}
      tabIndex={0}
      style={isSelected ? { backgroundColor: 'var(--color-shade-30)' } : {}}
    >
      <div className={styles.SuggestionName}>
        <Typography variant="title-medium">
          {capitalizedName.substring(0, startIndex)}
          <span className={styles.HighlightedSubstring}>
            {capitalizedName.substring(startIndex, endIndex)}
          </span>
          {capitalizedName.substring(endIndex, capitalizedName.length)}
        </Typography>
      </div>

      <div
        className={styles.SuggestionCategory}
        style={isSelected ? { display: 'block' } : {}}
      >
        {data.categoryType}
      </div>
    </div>
  );
};

export default ReasonForVisitSuggestion;
